import React, { useRef } from 'react'
import { Menu } from 'antd'
import { Grade, Module } from 'api/org'
import { hideOutline, ObsKeyToURL } from '../../api/utils'
import './side.less'
import { useHistory } from 'react-router-dom'
import { useState } from 'react'
import { useEffect } from 'react'

interface Props {
  id: string
  module: Module
  modules: Module[]
  courseView: string
  setGrade: (g: Grade) => void
  setModule: (type: Module) => void
  setCoursetView: (courseView: string) => void
}
const SideBar: React.FC<Props> = ({
  id,
  setGrade,
  modules,
  module,
  courseView,
  setModule,
  setCoursetView,
}) => {
  const history = useHistory()
  const [selectKey, setSelectedKey] = useState(id)
  const showOutline = (m: Module) => {
    setModule(m)
    setCoursetView('outline')
    setSelectedKey('')
  }

  useEffect(() => {
    setSelectedKey(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.pathname])

  // 修复首次登录，页面无响应
  const once = useRef(true)
  useEffect(() => {
    if (once.current && modules.length > 0) {
      for (let i = 0; i < modules.length; i += 1) {
        if (!once.current) {
          break
        }
        const grades = modules[i].grades
        for (let j = 0; j < grades.length; j += 1) {
          const grade = grades[j]
          if (grade.id === Number(selectKey)) {
            once.current = false
            setGrade(grade)
            break
          }
        }
      }
    }
  }, [modules, selectKey])

  return (
    <>
      {modules.map(item => (
        <div key={item.id} className="grade-title-group-outer">
          <div className="grade-title-group">
            <img src={ObsKeyToURL(item.image)} alt="module" />
          </div>
          <div
            className={`outline-btn bold second-title ${hideOutline(item.id) ? 'hide' : ''} ${courseView === 'outline' && module?.id === item.id ? 'outline-btn-active' : ''
              }`}
            onClick={() => showOutline(item)}
          >
            课程大纲
          </div>
          <Menu mode="inline" selectedKeys={[selectKey]}>
            {item.grades.map(grade => (
              <Menu.Item
                className="grade-title-item"
                key={grade.id}
                onClick={() => {
                  setGrade(grade)
                  setModule(item)
                }}
              >
                {grade.name}
              </Menu.Item>
            ))}
          </Menu>
        </div>
      ))}
    </>
  )
}

export default SideBar
